<template>
  <div class="move-print-container" id="print-move">
    <div class="top-info">
      <div class="title">
        <span>移库单号：{{ move.moveNo }}</span>
      </div>
      <div class="bar-code">
        <vue-barcode :value="move.moveNo" format="CODE128" height="60px" width="2px">
          移库单号：{{ move.moveNo }}
        </vue-barcode>
      </div>
    </div>

    <div class="middle-info">
      <div class="row">
        <div class="label">移库类型</div>
        <div class="value">{{ move.moveType | getLabelByCodeFilter("MOVE_TYPE") }}</div>
      </div>
      <div class="row">
        <div class="label">移库状态</div>
        <div class="value">{{ move.moveStatus | getLabelByCodeFilter("MOVE_STATUS") }}</div>
      </div>
      <div class="row">
        <div class="label">移库总数量</div>
        <div class="value">{{ moveSum }}</div>
      </div>
      <div class="row all">
        <div class="label">备注</div>
        <div class="value">{{ move.remark }}</div>
      </div>
      <div class="row">
        <div class="label">创建人</div>
        <div class="value">{{ move.creator.userName }}</div>
      </div>
      <div class="row">
        <div class="label">创建时间</div>
        <div class="value">{{ move.createTime }}</div>
      </div>
      <div class="row">
        <div class="label">操作人</div>
        <div class="value bottom-line"></div>
      </div>
      <div class="row">
        <div class="label">操作时间</div>
        <div class="value bottom-line"></div>
      </div>
    </div>

    <div class="table-info">
      <table class="xiaobu-table">
        <thead class="table-header">
          <tr class="xiaobu-table-row">
            <th class="xiaobu-table-header-cell">商品名称</th>
            <th class="xiaobu-table-header-cell">规格</th>
            <th class="xiaobu-table-header-cell">生产日期</th>
            <th class="xiaobu-table-header-cell">成本单价(元)</th>
            <th class="xiaobu-table-header-cell">原始仓库</th>
            <th class="xiaobu-table-header-cell">目标仓库</th>
            <th class="xiaobu-table-header-cell">库存数量</th>
            <th class="xiaobu-table-header-cell">移库数量</th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr class="xiaobu-table-row" v-for="(item, index) in list" :key="index">
            <td class="xiaobu-table-row-cell">{{ item.goodsName }}</td>
            <td class="xiaobu-table-row-cell">{{ item.skuListStr }}</td>
            <td class="xiaobu-table-row-cell">{{ item.manufactureDate }}</td>
            <td class="xiaobu-table-row-cell">{{ item.costPrice }}</td>
            <td class="xiaobu-table-row-cell">{{ getWareHouseName(item.wareHouseId) }}</td>
             <td class="xiaobu-table-row-cell">{{ getWareHouseName(item.moveWareHouseId) }}</td>
            <td class="xiaobu-table-row-cell">{{ item.spuNumber }}</td>
            <td class="xiaobu-table-row-cell">{{ item.moveNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// 条形码组件的value值不能有中文
import VueBarcode from "vue-barcode"
import printJS from "print-js"
import { getPathByTreeValue } from "vue2-element-admin-plugin"

export default {
  name: "MovePrint",
  props: {
    spuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    moveData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    VueBarcode
  },
  watch: {
    spuList: {
      handler(val) {
        this.list = val
      },
      immediate: true
    },
    moveData: {
      handler(val) {
        this.move = val
      },
      immediate: true
    }
  },
  computed: {
    moveSum() {
      return this.list.reduce((pre, cur) => {
        return pre + cur.moveNumber
      }, 0)
    }
  },
  data() {
    return {
      list: [],
      move: {
        moveNo: "",
        moveStatus: "",
        moveType: "",
        wareHouseId: "",
        wareHouseName: "",
        creator: {
          userName: ""
        },
        remark: ""
      }
    }
  },
  methods: {
    // 获取仓库名字
    getWareHouseName(val) {
      const wareHouseId = Array.isArray(val) ? val[val.length - 1] : val
      const list = getPathByTreeValue(this.wareHouseData, wareHouseId, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    print() {
      printJS({
        printable: "print-move",
        type: "html",
        targetStyles: ["*"],
        scanStyles: false,
        style: `
          @page {
            size: A4 landscape;
          }
          .top-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .top-info .title {
            font-size: 28px;
            color: #000000;
          }

          .middle-info {
            width: 100%;
          }

          .middle-info:after {
            visibility: hidden;
            display: block;
            font-size: 0;
            content: " ";
            clear: both;
            height: 0;
          }

          .middle-info .row {
            width: 50%;
            min-height: 40px;
            line-height: 24px;
            padding: 8px 0;
            font-size: 18px;
            color: #000;
            float: left;
            display: flex;
          }

          .middle-info .row.all {
            width: 100%;
          }

          .middle-info .row .label {
            width: 168px;
            flex-shrink: 0;
          }
          
          .middle-info .row .value.bottom-line{
            position: relative;
          }
          .middle-info .row .value.bottom-line::after {
            content: '' !important;
            width: 256px;
            height: 1px;
            background: #000000;
            position: absolute;
            bottom: -8px;
            left: 0;
          }
          .table-info {
            margin-top: 20px;
          }
          .table-info .xiaobu-table {
            width: 100%;
          }
          .table-info .xiaobu-table .xiaobu-table-row .xiaobu-table-header-cell,
          .table-info .xiaobu-table .xiaobu-table-row .xiaobu-table-row-cell {
            height: 50px;
            line-height: 50px;
            text-align: center;
          }

          @media print {
            .move-print-container {
              page-break-after: always;
            }
            .el-table__header-wrapper {
              display: table-header-group;
            }
            .el-table__body-wrapper {
              display: table-row-group;
            }
          }
        `
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.move-print-container {
  // 不在页面上显示  设置 display none 会导致打印不出来
  position: absolute;
  height: 0;
  overflow: hidden;

  .top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 28px;
      color: #000000;
    }
  }

  .middle-info {
    width: 100%;

    &:after {
      visibility: hidden;
      display: block;
      font-size: 0;
      content: " ";
      clear: both;
      height: 0;
    }

    .row {
      width: 50%;
      min-height: 48px;
      line-height: 24px;
      padding: 12px 0;
      font-size: 18px;
      color: #000;
      float: left;
      display: flex;

      &.all {
        width: 100%;
      }

      .label {
        width: 168px;
        flex-shrink: 0;
      }

      .value.bottom-line {
        position: relative;

        &::after {
          content: '';
          width: 200px;
          height: 1px;
          background: #000000;
          position: absolute;
          bottom: -8px;
          left: 0;
        }
      }
    }
  }

  .table-info {
    margin-top: 20px;

    .xiaobu-table {
      width: 100%;

      .xiaobu-table-row {

        .xiaobu-table-header-cell,
        .xiaobu-table-row-cell {
          height: 50px;
          line-height: 50px;
          text-align: center;
        }
      }
    }
  }

  @media print {
    .move-print-container {
      page-break-after: always;
    }

    .el-table__header-wrapper {
      display: table-header-group;
    }

    .el-table__body-wrapper {
      display: table-row-group;
    }
  }
}
</style>